import { useScrollToTop } from './services/ScrollToTop.hooks';

export default function ScrollToTop() {
  useScrollToTop();

  return null;
}
